import { Observable, ReplaySubject } from "rxjs";

export class ConvertionUtils {

    static stringToDateTime(dateTime: string) : Date {
      var toRet = new Date();
      var date = dateTime.split('T');
      var dateData = date[0].split('-');
      toRet.setFullYear(Number(dateData[0]), Number(dateData[1]) - 1, Number(dateData[2]));
      var timeData = date[1].split(':');
      toRet.setHours(Number(timeData[0]), Number(timeData[1]));
      return toRet;
    }
    
    static convertFileBytesToString(file: File): Observable<string> {
      const result = new ReplaySubject<string>(1);
      const reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = (event) => result.next(btoa(event.target.result.toString()));
      return result;
    }

}